/**
* id.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2018
*/
import dynamicProto from "@microsoft/dynamicproto-js";
import { createGuid, generateW3CId } from "@microsoft/applicationinsights-core-js";
var Id = /** @class */ (function () {
    function Id(core) {
        var lastPageViewId = createGuid();
        var internalTraceId = generateW3CId();
        dynamicProto(Id, this, function (_self) {
            _self.getTraceId = function () {
                if (core && core.getTraceCtx) {
                    return core.getTraceCtx().getTraceId() || internalTraceId;
                }
                return internalTraceId;
            };
            _self.getLastPageViewId = function () {
                return lastPageViewId;
            };
        });
    }
    Id.prototype.getTraceId = function () {
        // @DynamicProtoStub - DO NOT add any code as this will be removed during packaging
        return null;
    };
    Id.prototype.getLastPageViewId = function () {
        // @DynamicProtoStub - DO NOT add any code as this will be removed during packaging
        return null;
    };
    return Id;
}());
export { Id };
//# sourceMappingURL=Id.js.map